import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { IOSSwitch } from '../common/IosSwitch';
import { PLATE_TYPE, TITLE_STATUS, TRANSACTION_TYPE } from './contants';
import { useDispatch, useSelector } from 'react-redux';
import { selectTransactionInfo } from '../../redux-state/selectors';
import { useEffect, useState } from 'react';
import { UPDATE_TRANSACTION_INFO } from '../../redux-state/forms/types';
import CurrencyTextField from '../common/CurrencyField'

function TransactionForm({ errors }) {
  const dispatch = useDispatch();
  const transactionInfo = useSelector(selectTransactionInfo);
  const [isOptionalFieldVisible, setIsOptionalFieldVisible] = useState(false);

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_TRANSACTION_INFO,
      payload: { key, value },
    });
  };

  useEffect(() => {
    if (!transactionInfo?.transactionType) {
      const defaultType = Object.keys(TRANSACTION_TYPE)[0];
      dispatch({
        type: 'UPDATE_TRANSACTION_INFO',
        payload: {
          key: 'transactionType',
          value: defaultType,
        },
      });
    }
  }, [dispatch, transactionInfo?.transactionType]);

  const getShortPlateType = (input) => {
    for (let key in PLATE_TYPE) {
      if (PLATE_TYPE[key] === input) return key;
    }
    return input;
  }


  return (
    <div className="flex flex-col w-full gap-4">
      <div className="p-4 rounded-xl bg-white text-gray-700">
        <div className="text-lg font-bold">Transaction Info</div>

        <div className="flex flex-wrap justify-end mt-2 text-sm">
          <div className="text-gray-600 font-bold">
            Plate Transfer
            <FormControlLabel
              control={
                <IOSSwitch
                  sx={{ ml: 3 }}
                  checked={transactionInfo?.plateTransfer}
                  onChange={(e) =>
                    handleChange('plateTransfer', e.target.checked)
                  }
                />
              }
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row mt-4 gap-4 w-full">
          <CurrencyTextField
            label="Base Price"
            name="basePrice"
            required
            value={transactionInfo?.basePrice} // store number (or '' when empty)
            onChange={(num) => handleChange('basePrice', num)} // dispatch to Redux
            error={!!errors?.basePrice}
            helperText={errors?.basePrice}
          />

          <FormControl fullWidth required error={errors?.plateType}>
            <InputLabel>Plate Type</InputLabel>
            <Select
              label="Plate Type"
              value={getShortPlateType(transactionInfo?.plateType)}
              onChange={(e) => handleChange('plateType', e.target.value)}
            >
              {Object.keys(PLATE_TYPE).map((key) => (
                <MenuItem value={key} key={key}>
                  {PLATE_TYPE[key]}
                </MenuItem>
              ))}
            </Select>
            {errors?.plateType && (
              <div style={{ color: 'red', fontSize: '0.75rem' }}>
                {errors.plateType}
              </div>
            )}
          </FormControl>
        </div>

        <div className="flex flex-col md:flex-row mt-4 gap-4 pb-4 w-full">
          <FormControl fullWidth required error={!!errors?.transactionType}>
            <InputLabel>Transaction Type</InputLabel>
            <Select
              label="Transaction Type"
              value={transactionInfo?.transactionType || Object.keys(TRANSACTION_TYPE)[0]}
              onChange={(e) => handleChange('transactionType', e.target.value)}
            >
              {Object.entries(TRANSACTION_TYPE).map(([key, label]) => (
                <MenuItem value={key} key={key}>
                  {label}
                </MenuItem>
              ))}
            </Select>
            {errors?.transactionType && (
              <div style={{ color: 'red', fontSize: '0.75rem' }}>
                {errors.transactionType}
              </div>
            )}
          </FormControl>


          <FormControl fullWidth required error={!!errors?.titleStatus}>
            <InputLabel>New/Used</InputLabel>
            <Select
              label="Title Status"
              value={transactionInfo?.titleStatus}
              onChange={(e) => handleChange('titleStatus', e.target.value)}
            >
              {Object.keys(TITLE_STATUS).map((key) => (
                <MenuItem value={key} key={key}>
                  {TITLE_STATUS[key]}
                </MenuItem>
              ))}
            </Select>
            {errors?.titleStatus && (
              <div style={{ color: 'red', fontSize: '0.75rem' }}>
                {errors.titleStatus}
              </div>
            )}
          </FormControl>
        </div>

        <div className="flex items-center mt-4">
          Taxable Fees
          <FormControlLabel
            control={
              <IOSSwitch
                sx={{ ml: 3 }}
                checked={isOptionalFieldVisible}
                onChange={(e) => setIsOptionalFieldVisible(e.target.checked)}
              />
            }
          />
        </div>

        {isOptionalFieldVisible && (
          <div className="space-y-4 mt-4">
            <div className="flex flex-col md:flex-row gap-4 w-full">
              <CurrencyTextField
                label="Doc Fees"
                name="DocFees"
                value={transactionInfo?.DocFees ?? ''}
                onChange={(num) => handleChange('DocFees', num)}
                InputProps={{ style: { borderRadius: '10px' } }}
              />

              <CurrencyTextField
                label="Extended Warranties"
                name="Extended Warranties"
                value={transactionInfo?.ExtendedWarrantiesField} // store number (or '' when empty)
                onChange={(num) => handleChange('ExtendedWarrantiesField', num)} // dispatch to Redux
              />
            </div>

            <div className="flex flex-col md:flex-row gap-4 w-full">
              <CurrencyTextField
                label="Additional Fees"
                name="Additions"
                value={transactionInfo?.Additions ?? ''}   // keep controlled
                onChange={(num) => handleChange('Additions', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />

              <CurrencyTextField
                label="Protection Packages"
                name="ProtectionPackageField"
                value={transactionInfo?.ProtectionPackageField}  // keep controlled
                onChange={(num) => handleChange('ProtectionPackageField', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />            
            </div>

            <div className="flex flex-col md:flex-row gap-4 w-full">
                <CurrencyTextField
                label="Theft Protection"
                name="TheftProtectionField"
                value={transactionInfo?.TheftProtectionField}   // keep controlled
                onChange={(num) => handleChange('TheftProtectionField', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />
              
                <CurrencyTextField
                label="Insurance Packages"
                name="InsurancePackages"
                value={transactionInfo?.InsurancePackages}   // keep controlled
                onChange={(num) => handleChange('InsurancePackages', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />
            </div>

            <div className="flex flex-col md:flex-row gap-4 w-full">
              <CurrencyTextField
                label="Delivery Fees"
                name="DeliveryFees"
                value={transactionInfo?.DeliveryFees}   // keep controlled
                onChange={(num) => handleChange('DeliveryFees', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />

              <CurrencyTextField
                label="Dealer Service Fees"
                name="DealerServiceFees"
                value={transactionInfo?.DealerServiceFees}   // keep controlled
                onChange={(num) => handleChange('DealerServiceFees', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />
            </div>

            <div className="flex flex-col md:flex-row gap-4 w-full">
              <TextField
                label="Trade In Year"
                variant="outlined"
                fullWidth
                value={transactionInfo?.TradeInYear}
                onChange={(e) => handleChange('TradeInYear', e.target.value)}
                InputProps={{ style: {  borderRadius: '10px' } }}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  maxLength: 4,
                }}
              />

              <CurrencyTextField
                label="Trade In Value"
                name="TradeInValue"
                value={transactionInfo?.TradeInValue}   // keep controlled
                onChange={(num) => handleChange('TradeInValue', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />
            </div>

            <div className="flex flex-col md:flex-row gap-4 w-full">
              <CurrencyTextField
                label="Manufacturer Rebate"
                name="ManufacturerRebate"
                value={transactionInfo?.ManufacturerRebate}   // keep controlled
                onChange={(num) => handleChange('ManufacturerRebate', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />

              <CurrencyTextField
                label="Dealer Inventory Tax"
                name="DealerInventoryTax"
                value={transactionInfo?.DealerInventoryTax}   // keep controlled
                onChange={(num) => handleChange('DealerInventoryTax', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }}
              />
            </div>
            
            <div className="flex flex-col md:flex-row gap-4 w-full">
              <CurrencyTextField
                label="EV Tax Credit"
                name="TaxCredit"
                value={transactionInfo?.TaxCredit}   // keep controlled
                onChange={(num) => handleChange('TaxCredit', num)}  // num is Number | ''
                InputProps={{ style: { borderRadius: '10px' } }} 
              />

              <div className="w-full hidden md:block" />  
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default TransactionForm;
